/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/statistics/components/artikel-einkauf/statistics.artikel-einkauf.component.ts.
 */
import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {StatisticsService} from '../../services/statistics.service';
import {Lieferkunde} from '../../../../models/lieferkunde';
import {ArtikelEinkaufsStatistic} from '../../model/artikel-einkaufs-statistic';
import {BehaviorSubject} from 'rxjs';
import {SupplierOrderStatisticEntry} from '../../../../models/supplier-order-statistic-entry';

/**
 * Zweck: Beschreibt class StatisticsArtikelEinkaufComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'statistic-artikel-einkauf',
    templateUrl: 'statistics.artikel-einkauf.component.html',
    styleUrls: ['statistics.artikel-einkauf.component.scss'],
    standalone: false
})
export class StatisticsArtikelEinkaufComponent implements OnInit, OnChanges {
  @Input() artNr: number;
  @Input() artName: string;
  @Input() lcustomers: Lieferkunde[];
  @Input() year: string;

  @Input() supplierStats: SupplierOrderStatisticEntry[];

  data = new BehaviorSubject<ArtikelEinkaufsStatistic>(null);
  loading = new BehaviorSubject(false);

  factor = 0;

  months = {
    1: 'Jänner',
    2: 'Februar',
    3: 'März',
    4: 'April',
    5: 'Mai',
    6: 'Juni',
    7: 'Juli',
    8: 'August',
    9: 'September',
    10: 'Oktober',
    11: 'November',
    12: 'Dezember'
  };

  monthsNums = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private svc: StatisticsService) {
  }

/**
 * Beschreibt Methode ngOnChanges und ihren Rückgabevertrag.
 */
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.year) {
      this.load();
    }
  }

/**
 * Beschreibt Methode load und ihren Rückgabevertrag.
 */
  load() {
    this.loading.next(true);
    this.svc.getArtikelEinkaufsstatistikForArticle(this.lcustomers, this.artNr, this.year).subscribe(d => {
      let maxLieferMng = 0;
      let maxRechMng = 0;
      for (let i = 1; i <= 12; i++) {
        if (d[i] && d[i].lieferMng > maxLieferMng) {
          maxLieferMng = d[i].lieferMng;
        }
        if (d[i] && d[i].rechMng > maxRechMng) {
          maxRechMng = d[i].rechMng;
        }

      }

      let mng = 1;

      if (maxRechMng > maxLieferMng) {
        mng = maxRechMng;
      } else {
        mng = maxLieferMng;
      }

      this.factor = (100 / mng);
      this.data.next(d);
      this.loading.next(false);
    });
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
  }
}
